<template></template>

<script>
import firebase from "firebase/app";
export default {
  name: "returns",
  data() {
    return {
      invoices: [],
    };
  },
  created() {
    this.open();
  },
  methods: {
    open() {
      this.$prompt("Please input invoice no", "Find Invoice", {
        confirmButtonText: "Find",
        cancelButtonText: "Cancel",
        closeOnClickModal: true,
        showCancelButton: false,
        showClose: true,
        center: true,
        customClass: ".promptBox",
        inputErrorMessage: "Invalid No",
      })
        .then(({ value }) => {
          const docRef = this.$store.state.secondaryDatabase.collection("invoices");
            let firestoreQuery = docRef;
            if(this.$store.state.noDB === true) {
              firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
            } 
            firestoreQuery
            .where("invoiceNo", "==", value)
            .limit(1)
            .get()
            .then((querySnapshot) => {
               
              querySnapshot.forEach((doc) => {
                const data = {
                  id: doc.id,
                  data: doc.data(),
                };
                this.invoices.push(data);
                
              });
              if (!this.invoices[0]) {
                this.$notify({
                  type: "error",
                  message: "Invoice not found for no " + value,
                });
                return this.open();
              } else
                this.$router.push(
                  `/admin/createinvoice?invoice=${value}&return=true`
                );
            })
            .catch((error) => alert(error.message));
        })
        .catch((error) => {
          this.$message({
            type: "info",
            message: error.message,
          });
        });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/Returns.vue